import {SxProps} from '@mui/material';

const styles: Record<string, SxProps> = {
  passwordContainer: {
    marginBottom: '0.75rem',
  },
};

export default styles;
